"use client";
import { TextGenerateEffect } from "../../components/ui/text-generate-effect";

const words =
  "Copy paste the most trending components and use them in your websites without having to worry about styling and animations.";
export function TextGenerateEffectDemo() {
  return <TextGenerateEffect words={words} />;
}
